import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=fa87f1aa&scoped=true&"
import script from "./activityDetails.vue?vue&type=script&lang=js&"
export * from "./activityDetails.vue?vue&type=script&lang=js&"
import style0 from "./activityDetails.vue?vue&type=style&index=0&id=fa87f1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa87f1aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fa87f1aa', component.options)
    } else {
      api.reload('fa87f1aa', component.options)
    }
    module.hot.accept("./activityDetails.vue?vue&type=template&id=fa87f1aa&scoped=true&", function () {
      api.rerender('fa87f1aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\activities\\activityDetails.vue"
export default component.exports